/** Quién paga la orden. */
export enum EPayerType {
    HEALTH_ENTITY = 1,
    PATIENT = 2,
}
